export default "__VITE_ASSET__CX8QiY50__"